import { useState, useEffect } from "react";

// Reports whether the device has a fine pointer that can hover. Pointer-driven
// enhancements (custom cursor, 3D card tilt) should only run when this is true,
// so their listeners and math are never attached on touch/coarse-pointer
// devices. SSR-safe: returns false until mounted, matching the first client
// render.
export function useFinePointer() {
  const [fine, setFine] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
    const update = () => setFine(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return fine;
}
